import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { updateSectionFourTwoRecord } from "../utils/update-section-four-two-record";

interface IRequest {
  mainJournalId: string;
  section4Id: string;
  section4ListId: string;
  itemPartOneId: string;
  itemPartTwo: {
    defectFixingFactDate: string;
    createOtherDocs: {
      fileMetadata: {
        fileNumber: number;
        fileName: string;
        fileType: string;
        fileContentLength: number;
        id?: string;
        fileId?: string;
      };
      file?: File;
    }[];
    defectFixingInspectionEmployeeId: string;
    deleteOtherDocs?: {
      file: {
        id: string;
        fileId: string;
      };
    }[];
  };
}

export function useUpdateSectionFourTwoEntry({
  itemNoVersionId,
  section4ListId,
}: {
  itemNoVersionId: string;
  section4ListId: string;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IRequest) =>
      updateSectionFourTwoRecord({
        itemNoVersionId,
        updateSectionFourRequest: data,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSection4({ section4ListId }).queryKey,
      });
      notification.success({
        message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
        description: NOTIFICATION_MESSAGES.ENTRY_UPDATED_DESC, // "Запись обновлена"
      });
    },
    onError: () => {
      notification.error({
        message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
        description: NOTIFICATION_MESSAGES.ENTRY_UPDATE_FAILED_DESC, // "Не удалось обновить запись"
      });
    },
  });
}

